import { config } from "@/config/eventConfig";
import { useRightNow } from "@/context/RightNowContext";

// One sentence per step, updating as the user moves. Participant voice only.
export const RightNowBar = () => {
  const { position } = useRightNow();
  if (!position?.areaId && !position?.override) return null;

  let sentence = null;
  if (position.override) {
    sentence = position.override;
  } else {
    const steps = config.content?.[position.areaId]?.steps || [];
    const step = steps[position.stepIndex];
    const v = step?.right_now || {};
    sentence = v.nonprofit ?? null;
  }
  if (!sentence) return null;

  return (
    <div data-testid="right-now-bar" className="bg-white border-b border-sand">
      <div className="max-w-5xl mx-auto w-full px-6">
        <div className="border-l-4 border-teal pl-5 py-3 flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-4">
          <span className="mono-label text-teal shrink-0">Right now</span>
          <span data-testid="right-now-text" className="text-ink">
            {sentence}
          </span>
        </div>
      </div>
    </div>
  );
};
